export function isChangeDetailsValid(changeDetailsState) {
  const {
    isMtaStartDateValid,
    isMtaReasonValid,
    isMtaStartDateEntered,
  } = changeDetailsState;

  return isMtaStartDateValid && isMtaStartDateEntered && isMtaReasonValid;
}
